<template>
  <!--subPage 상단 Navi-->
  <div class="sub_Navi">
    <ul>
      <li><a class="back" @click="changeFAQState">뒤로</a></li>
      <li><h1>FAQ</h1></li>
      <li class="linkBox"></li>
    </ul>
  </div>
  <!--//subPage 상단 Navi :End-->
  <!--subPage -->
  <div class="subPage_container">
    <div class="bbs_info">
      <h5>고야앱 알림 사용 가이드</h5>
      <p class="time">
        2024-02-27 12:30 <span class="view">5,400</span>
        <a href="#none" class="download">다운로드</a>
      </p>
    </div>
    <div class="bbs_view_wrap">
      <p>
        고야앱에서 알림서비스를 받기 위해서는 알림 받고 싶은 코인을 먼저
        추가하여 설정해주셔야 합니다.
      </p>
      <img src="@/assets/images/common/chart_sample_01.png" />
    </div>
  </div>
  <!--//subPage_container :End -->
  <!--//subPage :End -->
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "FAQDetail",
  computed: {
    ...mapState("board", ["clickFAQ"]),
  },
  methods: {
    ...mapMutations("board", ["changeFAQ"]),

    changeFAQState() {
      this.changeFAQ({ state: false });
    },
  },
};
</script>
